import React, {useState, useEffect, useCallback} from 'react'

import {ChevronDownIcon} from '@heroicons/react/24/solid';
import { 
  ButtonGroup, 
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography, 
  Textarea,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Input,
  Spinner,
  IconButton,
  Slider,
  Select, 
  Option,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Tooltip
} from "@material-tailwind/react";

import { ArrowRightIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import { v4 as uuidv4 } from 'uuid';
import { getPaymentHistoryNew, cancelPRVInscriptionContent, savePaymentHistoryNew } from '../../util/new-api';

import { encodedAddressPrefix, tippingAddress, ownerAddress, royalty, tip, contentLength, serviceFeeRate, padding, royalty_pa, dust20Fee } from '../../configs/constant';

import { getFeeRate, bytesToHex, buf2hex, textToHex, hexToBytes, getMempoolUtxos, loopTilAddressReceivesMoney, waitSomeSeconds, addressReceivedMoneyInThisTx, pushBTCpmt, calculateFeeNew, getData, isValidTaprootAddress} from '../../util/inscribe-util';

import { CheckIcon } from '@heroicons/react/24/solid';
import { useParams } from 'react-router-dom';
import { sendBtcTransaction } from 'sats-connect';
import FeeRateCard from '../../components/FeeRateCard';
import { BitcoinNetworkType, signMessage, signTransaction } from 'sats-connect';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import toast, { Toaster } from 'react-hot-toast';
import { useWallet, useWallets } from '@wallet-standard/react';
import { useSelector, useDispatch } from 'react-redux';
import { validTapTicker } from '../../util/format-data';
import { latestTokenNew, getPATokenWhitelistAddressCheck } from '../../util/new-api';
import { formatAddress, formatAddressMicroText, formatInscriptionId, formatAddressMicro } from '../../util/format-data';
import { useTranslation } from 'react-i18next';
import { getDust20CheckTicker, saveDust20, getDust20Indexer, getDust20TickerDetail, getPaymentUtxosForDust20, getDust20SplitMergePsbt } from '../../util/dust20-api';
import { debounce } from 'lodash';
import { launchpadTokenRandom } from '../../util/new-api';
import { getDust20BalanceTicker } from '../../util/dust20-api';
import Dust20TransferCard from '../../components/TokenSaleCard/Dust20TransferCard';
import { ExclamationCircleIcon, TrashIcon } from '@heroicons/react/24/outline';
import { calculateMultiFee, handleAddressUpdate } from '../../util/format-data';
import { getBtcUtxos } from '../../util/ordinal';
import { dust20TransferFee } from '../../configs/constant';
import { getDust20FilterUtxos } from '../../util/dust20-api';

export default function Dust20Inscribe() {
  const { param } = useParams();
  const { wallets } = useWallets();

  const SatsConnectNamespace = 'sats-connect:';

  const { t, i18n } = useTranslation();
  const isSatsConnectCompatibleWallet = (wallet) => {
      return SatsConnectNamespace in wallet.features;
  }

  const wallet = useSelector(state => state.wallet);

  const { Address, Script, Signer, Tap, Tx } = window.tapscript;
  const feeRateTabs = ["Slow", "Normal", "Fast", "Custom"];

  const [feeRateMode, setFeeRateMode] = useState("Normal");
  const [feerate, setFeerate] = useState(0);
  const [feeRates, setFeeRates] = useState({});
  const [feeValues, setFeeValues] = useState({
    "inscriptionFee": 0,
    "networkFee": 0,
    "serviceFee": 0,
    "royaltyFee": 0,
    "totalFee": 0
  });

  const [loading, setLoading] = useState(false);
  const [customFee, setCustomFee] = useState(0);
  const [sliderValue, setSliderValue] = useState(2);
  const [show, setShow] = useState(false);
  const [inscriptionStatus, setInscriptionStatus] = useState(false);
  const [showFeeRateCard, setShowFeeRateCard] = useState(false);

  const [type, setType] =  useState(param == '' ? 0 : 1);
  const [ticker, setTicker] = useState(param);
  const [supply, setSupply] = useState(1000000);
  const [unitSats, setUnitSats] = useState(546);
  const [maxSats, setMaxSats] = useState(546000000);
  const [limSats, setLimSats] = useState('');
  const [mintText, setMintText] = useState('');
  const [outputSats, setOutputSats] = useState(546);
  const [amount, setAmount] = useState(1);
  const [isLoyalty, setIsLoyalty] = useState(1);
  const [isDeployTickerValid, setIsDeployTickerValid] = useState(0);
  const [receiveAddress, setReceiveAddress] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [searchOutput, setSearchOutput] = useState('');
  const [searchAmount, setSearchAmount] = useState(0);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [dust20Data, setDust20Data] =  useState([]);
  const [checkedData, setCheckedData] = useState([]);

  useEffect(() => {
    let intervalId;

    const updateFees = async () => {
      try {
        if (feeRateMode == "Custom") {
          setFeerate(parseFloat(customFee));
          setFeeValues(calculateFeeRandom(parseFloat(customFee), 1));
        }
        else
        {
          let response = await getFeeRate();
          setFeeRates(response);
          setFeerate(response[feeRateMode]);
          setFeeValues(calculateFeeRandom(response[feeRateMode], 1));
          if (customFee == 0) 
          {
            setCustomFee(response["Fast"] + 1);
          }
        }
      }
      catch (e) {
        console.log(e);
      }
    }
    updateFees();
    intervalId = setInterval(updateFees, 20 * 1000);
    return () => {
      clearInterval(intervalId);
    }
  }, [feeRateMode, amount, customFee, isLoyalty, outputSats])

  useEffect(() => {
    let value = (sliderValue / 100) * (500 - feeRates["Normal"]) + feeRates["Normal"];
    setCustomFee(Math.floor(value));
  }, [sliderValue])

  useEffect(() => {
    if (unitSats > 0 && supply > 0){
      setMaxSats(unitSats * supply);
    }
  }, [unitSats, supply])

  const next = () => {
    if (page === total) return;
    setPage(page + 1);
  };
 
  const prev = () => {
    if (page === 1) return;
    setPage(page - 1);
  };

  useEffect(() => {
    fetchDust20Utxos();
  }, [isDeployTickerValid])

  useEffect(() => { 
    setReceiveAddress(wallet.nostrOrdinalsAddress);
    handleRoyalty(wallet.nostrOrdinalsAddress);
  }, [wallet.nostrOrdinalsAddress]);

  useEffect(() => {
    setAmount(1);
    checkValidTicker(ticker);
  }, [type])

  const handleCheck = (checked, data) => {
    setCheckedData((prevCheckedData) => {
      if (checked) {
        return [...prevCheckedData, data];
      } else {
        return prevCheckedData.filter(temp => temp.output !== data.output);
      }
    });
  };

  const fetchDust20Utxos = async() => {
    if (type == 2 && isDeployTickerValid) {
      if (wallet.nostrOrdinalsAddress == '') {
        setErrorMessage(t('Connect Wallet Error Message'));
        return;
      }
      else {
        setErrorMessage('');
      }
      await fetchAllDust20(page, searchOutput, searchAmount);
    }
  }

  const fetchAllDust20 = async(page, output, amount) => {
    setLoading(true);
    try{
      let data = await getDust20BalanceTicker(wallet.nostrOrdinalsAddress, output, ticker, page, limit, amount);
      setTotal(Math.ceil(data.total / limit));
      setDust20Data(data.data);

      if (data.total == 0) {
        setErrorMessage('No Dust-20 Token.');
      }
      else {
        setErrorMessage('');
      }
    }
    catch(e) {
      setLoading(false);
    }
    setLoading(false);
  }

  const handleMintTicker = async (value) => {
    setTicker(value);
    debouncedCheckTickerIsValid(value);
  }

  const debouncedCheckTickerIsValid = useCallback(debounce(async (value) => {
    await checkValidTicker(value);
  }, 800), []); 

  const handleSearchOutput = (value) => {
    setSearchOutput(value);
    debouncedOutputSearch(1, value, searchAmount);
    setPage(1);
  }

  const debouncedOutputSearch = useCallback(debounce( async (page, output, amount) => {
    await fetchAllDust20(page, output, amount);
  }, 800), []); 

  const handleSearchAmount = (value) => {
    setSearchAmount(value);
    debouncedAmountSearch(1, searchOutput, value);
    setPage(1);
  }

  const debouncedAmountSearch = useCallback(debounce( async (page, output, amount) => {
    await fetchAllDust20(page, output, amount);
  }, 800), []); 

  const checkValidTicker = async (value) => {
    let result = await getDust20CheckTicker(value);
    if (result.status) {
      setIsDeployTickerValid(true);
    }
    else {
      setIsDeployTickerValid(false);
    }
  }

  const handleRoyalty = async(value) => {
    if (value == '') {
      setIsLoyalty(1);
    }
    else {
      let results = await launchpadTokenRandom(value, 1) // dustzero
      if (results.data.length > 0) {
        setIsLoyalty(0);
      }
      else setIsLoyalty(1);
    }
  }

  const handleType = (value) => {
    setType(value);
  }

  const handleTicker = (value) => {
    setTicker(value);
  }
  
  const handleReceiveAddress = (value) => {
    setReceiveAddress(value);
    debouncedHandleRoyalty(value);
  }

  const debouncedHandleRoyalty = useCallback(debounce(async (value) => {
    await handleRoyalty(value);
  }, 800), []); 

  const handleTransfer =  async () => {

    if (checkedData.length == 0) {
      toast.error(t("Select Utxos Error Message"));
      return;
    }

    if (!isValidTaprootAddress(receiveAddress)) {
      toast.error("Please insert valid taproot address!");
      return;
    }

    setLoading(true);
    let results = await launchpadTokenRandom(wallet.nostrOrdinalsAddress, 1) // dustzero

    let fundingAmount = 0;
    if (results.data.length == 0) {
      fundingAmount = dust20TransferFee;
    }

    let tempUtxos = await getBtcUtxos(wallet.nostrPaymentAddress);
    results = await getDust20FilterUtxos(tempUtxos);

    let receiveData = [
      {
        address: receiveAddress,
        amount: checkedData.reduce((total, data) => total + data.amount, 0)
      }
    ]
    let vins = {
      seg: 0,
      tap: checkedData.length,
      leg: 0,
      nesSeg: 0
    };

    let vouts = {
      seg: 0,
      tap: receiveData.length,
      leg: 0,
      nesSeg: 0
    };

    let sats = checkedData[0].value / checkedData[0].amount;

    if (fundingAmount > 0) {
      vouts.tap += 1;
    }

    let totalValue = 0;
    let utxos = [];
    for(let utxo of results) {
      totalValue += utxo.satoshis;
      utxos.push({
        txid: utxo.txid,
        value: utxo.satoshis,
        vout: utxo.vout
      })
      vins = handleAddressUpdate(vins, wallet.nostrPaymentAddress)
      if (totalValue > (calculateMultiFee(vins, vouts, feerate) + fundingAmount)) {
        break;
      }
    }

    let tempVouts = handleAddressUpdate(vouts, wallet.nostrPaymentAddress);
    let charge = totalValue - calculateMultiFee(vins, tempVouts, feerate) - fundingAmount;

    if (totalValue < calculateMultiFee(vins, vouts, feerate) + fundingAmount) {
      toast.error(t('Insufficient Balance Error Message'));
      setLoading(false);
      return;
    }

    let fundingAddress = ownerAddress;

    let selectedUtxos = []
    for(let temp of checkedData) {
      selectedUtxos.push({
        txid: temp.output.split(":")[0],
        vout: parseInt(temp.output.split(":")[1]),
        value: temp.value
      })
    }

    let param = {
      selectedData: selectedUtxos,
      receiveData,
      utxos,
      address : wallet.nostrPaymentAddress,
      pubkey : wallet.paymentPublicKey,
      charge,
      fundingAddress,
      fundingAmount,
      provider: wallet.domain,
      sats
    }

    const paymentUtxos = await getDust20SplitMergePsbt(param)

    let isSuccess = true;

    try{
      if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos);
        const txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos);
        const txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos);
        const txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let signIndexes = [];
        for(let i=0;i< utxos.length + selectedData.length; i++){
          signIndexes.push(i);
        }

        await signTransaction({
          payload: {
              network: {
                  type: BitcoinNetworkType.Mainnet,
              },
              psbtBase64: paymentUtxos,
              broadcast: true,
              message: "tip the author! Don't worry this will not be broadcasted.",
              inputsToSign: [
                  {
                      address: wallet.nostrPaymentAddress,
                      signingIndexes: signIndexes,
                  },
              ],
          },
          onFinish: async (response) => {
          },
          onCancel: () => {
              toast.error(t('Request canceled'));
              setLoading(false);
              isSuccess = false
              return;
          },
        });
       }
      else if (wallet.domain == "magiceden") {
        let signIndexes = [];
        for(let i=0;i<utxos.length + selectedData.length; i++){
          signIndexes.push(i);
        }

        let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

        await signTransaction({
          getProvider: async () =>
            magicedenWallets[0].features['sats-connect:'].provider,
          payload: {
              network: {
                  type: BitcoinNetworkType.Mainnet,
              },
              psbtBase64: paymentUtxos,
              broadcast: true,
              message: "tip the author! Don't worry this will not be broadcasted.",
              inputsToSign: [
                  {
                      address: wallet.nostrPaymentAddress,
                      signingIndexes: signIndexes,
                  },
              ],
          },
          onFinish: async (response) => { 
          },
          onCancel: () => {
              toast.error(t('Request canceled'));
              setLoading(false);
              isSuccess = false;
          },
        });
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setLoading(false);
        isSuccess = false;
        return;
      }
    }
    catch(e)
    {
      toast.error(t('User Reject Request Error Message'));
      isSuccess = false;
      setLoading(false);
      return;
    }
    if (isSuccess) {
      toast.success(t('Success!'));
    }
    setLoading(false);
  }

  const handleSubmit = async (value) => {
    setLoading(true);
    if (wallet.nostrOrdinalsAddress == "") {
      toast.error(t('Connect Wallet Error Message'));  
      setLoading(false);
      return;
    }

    if (type == 0) {
      if (ticker == "") {
        toast.error(t('Please Insert Ticker Error Message'));
        setLoading(false);
        return;
      }
      
      let results = await getDust20CheckTicker(ticker);
      if (results.status) {
        toast.error(t('Ticker Already Exist Error Message'));  
        setLoading(false);
        return;
      }

      if (unitSats == '' || parseInt(unitSats) <=0) {
        toast.error(t('Insert Valid Unit Sats Error Message'));  
        setLoading(false);
        return;
      }

      if (supply == '' || parseInt(supply) <=0) {
        toast.error(t('Insert Valid Supply Error Message'));  
        setLoading(false);
        return;
      }

      let tempText;
      if (limSats == '' || limSats == 0) {
        tempText = `{"p": "dust-20","op": "deploy","tick": "${ticker}","supply": "${supply}","unit_sats": "${unitSats}","max_sats": "${supply * unitSats}"}`;
      } 
      else {
        tempText = `{"p": "dust-20","op": "deploy","tick": "${ticker}","supply": "${supply}","unit_sats": "${unitSats}","max_sats": "${supply * unitSats}","lim_sats": "${limSats}"}`;
      }

      setMintText(tempText);
      setShowFeeRateCard(true);
      setOutputSats(546);
    }
    else if (type == 1) {
      if (ticker == "") {
        toast.error(t('Please Insert Ticker Error Message'));
        setLoading(false);
        return;
      }
      if (isDeployTickerValid == 0) {
        toast.error(t('Please Insert Valid Ticker Error Message'));
        setLoading(false);
        return;
      }

      let results = await getDust20TickerDetail(ticker);
      if (results.length == 0) {
        toast.error(t('Please Insert Valid Ticker Error Message'));
        setLoading(false);
      }

      if (amount <= 0) {
        toast.error(t('Insert Valid Amount Error Message'));
        setLoading(false);
        return;
      } 

      if (results[0].lim_sats > 0 && parseInt(amount) > results[0].lim_sats / results[0].unit_sats) {
        toast.error(t('Insert Valid Amount Error Message'));
        setLoading(false);
        return;
      }

      if (parseInt(amount) + parseInt(results[0].minted) > results[0].supply) {
        toast.error(t('Exceed Maximum Avaiable Balance Error Message'));
        setLoading(false);
        return;
      }

      let tempText = `{"p": "dust-20","op": "mint","tick": "${ticker}","amt": "${amount}","sats": "${amount * results[0].unit_sats}"}`;

      setMintText(tempText);
      setShowFeeRateCard(true);
      setOutputSats(amount * results[0].unit_sats);
    }
    else {
      
    }

    setLoading(false);
  }

  const checkValid = (value, data) => {
    for(let temp of data) {
      if (value.toUpperCase() == temp.ticker.toUpperCase()) return 1;
    }
    return 0;
  }

  const calculateFeeRandom = (feeRate, _mintCount ) => {
    let mintCount = parseInt(_mintCount);
    let dataSize = mintText.length;
    if (mintCount <= 0 || mintCount == NaN) mintCount = 1;
    let base_size = 160;
    let prefix = 160;
    let txsize = prefix + Math.floor(dataSize / 4);
    let inscriptionLength = mintCount;
    let inscriptionFee = outputSats ;
    let networkFee = Math.floor(feeRate * txsize);
  
    let tempFee = dust20Fee;
    if (type == 1 && tempFee < 0.05 * outputSats) tempFee = 0.05 * outputSats;
    let royaltyFee = tempFee * isLoyalty;

    let serviceFee = 0;
    let totalFee = inscriptionFee * mintCount + networkFee * mintCount + royaltyFee;
    return {
      "inscriptionFee": inscriptionFee,
      "networkFee": networkFee,
      "serviceFee": serviceFee,
      "royaltyFee": royaltyFee,
      "totalFee": totalFee
    }
  }  

  const handleMint = async () => {
    setLoading(true);
    setShowFeeRateCard(false);

    if (!isValidTaprootAddress(receiveAddress)) {
      toast.error(t('Insert Valid Taproot Address Error Message'));
      setLoading(false);
      return;
    }

    setLoading(false);
    setShow(true);
    setInscriptionStatus(false);

    const results = await getPaymentHistoryNew();
    const toggleValue = results[0].value;
    let fundingAddress = '';

    if (toggleValue == 0)
      fundingAddress = tippingAddress;
    else
      fundingAddress = ownerAddress;

    let isSuccess = true;

    let inscriptionFee = feeValues["inscriptionFee"] + feeValues["networkFee"];
    let fundingAmount = feeValues["serviceFee"] + feeValues["royaltyFee"];

    if (!typeof window) return
    if (!window.tapscript) return

    let cryptoUtils = window.cryptoUtils;
    const KeyPair = cryptoUtils.KeyPair;

    let privkey = bytesToHex(cryptoUtils.Noble.utils.randomPrivateKey());

    let seckey = new KeyPair(privkey);
    let pubkey = seckey.pub.rawX;

    const ec = new TextEncoder();

    const init_script = [
      pubkey,
      'OP_CHECKSIG'
    ];
    
    const init_script_backup = [
        '0x' + buf2hex(pubkey.buffer),
        'OP_CHECKSIG'
    ];

    let init_leaf = await Tap.tree.getLeaf(Script.encode(init_script));
    let [init_tapkey, init_cblock] = await Tap.getPubKey(pubkey, {target: init_leaf});

    const test_redeemtx = Tx.create({
      vin  : [{
          txid: 'a99d1112bcb35845fd44e703ef2c611f0360dd2bb28927625dbc13eab58cd968',
          vout: 0,
          prevout: {
              value: 10000,
              scriptPubKey: [ 'OP_1', init_tapkey ]
          },
      }],
      vout : [{
          value: 8000,
          scriptPubKey: [ 'OP_1', init_tapkey ]
      }],
    });
    
    const test_sig = await Signer.taproot.sign(seckey.raw, test_redeemtx, 0, {extension: init_leaf});
    test_redeemtx.vin[0].witness = [ test_sig.hex, init_script, init_cblock ];
    const isValid = await Signer.taproot.verify(test_redeemtx, 0, { pubkey });

    if(!isValid)
    {
      alert('Generated keys could not be validated. Please reload the app.');
      return;
    }

    let files = [];

    let mimetype = "text/plain;charset=utf-8";
    let salts = "";
    let tickerPubKey = "";

    for(let i = 0; i< 1; i++)
    {
      let text = mintText;

      files.push({
        text: JSON.stringify(text),
        name: textToHex(text),
        hex: textToHex(text),
        mimetype: mimetype,
        sha256: ''
      });
    }

    let inscriptions = [];
    let inscriptionAddressList = [];

    let recipientList = [];

    for (let i = 0; i < files.length; i++) {

      const hex = files[i].hex;
      const data = hexToBytes(hex);
      const mimetype = ec.encode(files[i].mimetype);

      const script = [
          pubkey,
          'OP_CHECKSIG',
          'OP_0',
          'OP_IF',
          ec.encode('ord'),
          '01',
          mimetype,
          'OP_0',
          data,
          'OP_ENDIF'
      ];

      const script_backup = [
          '0x' + buf2hex(pubkey.buffer),
          'OP_CHECKSIG',
          'OP_0',
          'OP_IF',
          '0x' + buf2hex(ec.encode('ord')),
          '01',
          '0x' + buf2hex(mimetype),
          'OP_0',
          '0x' + buf2hex(data),
          'OP_ENDIF'
      ];

      const leaf = await Tap.tree.getLeaf(Script.encode(script));
      const [tapkey, cblock] = await Tap.getPubKey(pubkey, { target: leaf });

      let inscriptionAddress = Address.p2tr.encode(tapkey, encodedAddressPrefix);

      let prefix = 160;

      let txsize = prefix + Math.floor(data.length / 4);

      inscriptionAddressList.push(inscriptionAddress);

      inscriptions.push(
        {
          leaf: leaf,
          tapkey: tapkey,
          cblock: cblock,
          inscriptionAddress: inscriptionAddress,
          txsize: txsize,
          fee: inscriptionFee - outputSats,
          script: script_backup,
          script_orig: script
        }
      );

      recipientList.push ({
        address: inscriptionAddress,
        amountSats: BigInt(inscriptionFee),
      })
    }
    
    recipientList.push({
      address: fundingAddress,
      amountSats: BigInt(fundingAmount),
    })

    let _fundingAddress = Address.p2tr.encode(init_tapkey, encodedAddressPrefix);

    // get payment utxos

    let tempfeerate = feerate;
    if (wallet.domain == "xverseWallet") tempfeerate = Math.ceil(feerate * 1.2);

    if (tempfeerate == null || tempfeerate == undefined || isNaN(tempfeerate)) {
      tempfeerate = 1.1;
    }

    const paymentUtxos = await getPaymentUtxosForDust20(wallet.nostrPaymentAddress, inscriptionAddressList, inscriptionFee, fundingAddress, fundingAmount, wallet.paymentPublicKey, tempfeerate, 1, wallet.domain)

    if (paymentUtxos.status == "fail") {
      alert(t('Insufficient Balance Error Message'));
      setLoading(false);
      setShow(false);
      isSuccess = false;
      
      return;
    }

    try{
      if (wallet.domain == "tapwallet") {
        const signedPsbt = await window.tapwallet.signPsbt(paymentUtxos.psbt);
        const txid = await window.tapwallet.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "unisat") {
        const signedPsbt = await window.unisat.signPsbt(paymentUtxos.psbt);
        const txid = await window.unisat.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "okxwallet") {
        const signedPsbt = await window.okxwallet.bitcoin.signPsbt(paymentUtxos.psbt);
        const txid = await window.okxwallet.bitcoin.pushPsbt(signedPsbt);
      }
      else if (wallet.domain == "xverseWallet") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          await signTransaction({
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
            },
            onCancel: () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
                setShow(false);
            },
          });
        }
        else {
            alert(t('Insufficient Balance Error Message'));
            setLoading(false);
            setShow(false);
            isSuccess = false;
            if (type == 0) {
              await cancelPRVInscriptionContent(ticker, tickerPubKey);
            }
            return;
        }
      }
      else if (wallet.domain == "magiceden") {
        let res = paymentUtxos;
        if (res.status == "success") {
          let signIndexes = [];
          for(let i=0;i<res.count; i++){
            signIndexes.push(i);
          }

          let magicedenWallets = wallets.filter(isSatsConnectCompatibleWallet);

          await signTransaction({
            getProvider: async () =>
              magicedenWallets[0].features['sats-connect:'].provider,
            payload: {
                network: {
                    type: BitcoinNetworkType.Mainnet,
                },
                psbtBase64: res.psbt,
                broadcast: true,
                message: "tip the author! Don't worry this will not be broadcasted.",
                inputsToSign: [
                    {
                        address: wallet.nostrPaymentAddress,
                        signingIndexes: signIndexes,
                    },
                ],
            },
            onFinish: async (response) => {
            },
            onCancel: () => {
                alert(t('Request canceled'));
                setLoading(false);
                isSuccess = false;
                setShow(false);
            },
          });
  
        }
        else {
          alert(t('Insufficient Balance Error Message'));
          setLoading(false);
          setShow(false);
          isSuccess = false;
          if (type == 0) {
            await cancelPRVInscriptionContent(ticker, tickerPubKey);
          }
          return;
        }
      }
      else {
        toast.error("This wallet does not support yet. Please wait!");
        setLoading(false);
        setShow(false);
        isSuccess = false;
        return;
      }
    }
    catch(e)
    {
      console.log(e);
      alert(t('User Reject Request Error Message'));
      isSuccess = false;
      setLoading(false);
      setShow(false);
      return;
    }

    if (isSuccess) {
      // save private key and public key
      let params = {
        key : privkey,
        address : receiveAddress,
        inscriptionAddress : inscriptions[0].inscriptionAddress,
        sats : outputSats,
        text : mintText
      }
      await saveDust20(params);

      let transactionData;
      while(true)
      {
        transactionData = await getMempoolUtxos(inscriptions[0].inscriptionAddress);
        if (transactionData.length >= 1){
          break;
        }
        await waitSomeSeconds(2);
      }

      for (let i = 0; i < inscriptions.length; i++) {
        await inscribe(inscriptions[i], i, transactionData[0].txid, transactionData[0].value, seckey);
        await waitSomeSeconds(2);
      }
    }

    await savePaymentHistoryNew(1 - toggleValue);

    setLoading(false);
    setInscriptionStatus(true);
  }
  
  const inscribe = async(inscription, vout, txid2, amt2, seckey) => {
    let _toAddress;
    let _script;
    let toAddress = receiveAddress;
    if(toAddress.startsWith('tb1q') || toAddress.startsWith('bc1q'))
    {
        _toAddress = Address.p2wpkh.decode(toAddress, encodedAddressPrefix).hex;
        _script = [ 'OP_0', _toAddress ];
        console.log('using p2wpkh', _script);
    }
    else if(toAddress.startsWith('1') || toAddress.startsWith('m') || toAddress.startsWith('n'))
    {
        _toAddress = Address.p2pkh.decode(toAddress, encodedAddressPrefix).hex;
        _script = Address.p2pkh.scriptPubKey(_toAddress);
        console.log('using p2pkh', _script);
    }
    else if(toAddress.startsWith('3') || toAddress.startsWith('2'))
    {
        _toAddress = Address.p2sh.decode(toAddress, encodedAddressPrefix).hex;
        _script = Address.p2sh.scriptPubKey(_toAddress);
        console.log('using p2sh', _script);
    }
    else
    {
        _toAddress = Address.p2tr.decode(toAddress, encodedAddressPrefix).hex;
        _script = [ 'OP_1', _toAddress ];
        console.log('using p2tr', _script);
    }

    const redeemtx = Tx.create({
        vin  : [{
            txid: txid2,
            vout: vout,
            prevout: {
                value: amt2,
                scriptPubKey: [ 'OP_1', inscription.tapkey ]
            },
        }],
        vout : [{
            value: outputSats,
            scriptPubKey: _script
        }],
    });

    const sig = await Signer.taproot.sign(seckey.raw, redeemtx, 0, {extension: inscription.leaf});
    redeemtx.vin[0].witness = [ sig.hex, inscription.script_orig, inscription.cblock ];

    console.dir(redeemtx, {depth: null});

    let rawtx2 = Tx.encode(redeemtx).hex;
    let _txid2;

    while(true) {
      _txid2 = await pushBTCpmt( rawtx2 );
      if (_txid2.length == 64) break;
      await sleep(5000);
    }
  }

  const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const handleCopy = (value) => {
    navigator.clipboard.writeText(value).then(
      () => {
          toast.success(t('Copied!'));
      },
      (err) => {
        // Failed to copy to clipboard
        console.error('Could not copy: ', err);
      }
    );
  }

  const handleCustomFee = (value) => {
    const sanitizedValue = value.replace(/[^0-9.]/g, '');
    setCustomFee(sanitizedValue);
  }

  return (
    <div className="text-white mt-[65px] w-full max-w-[1500px] md:px-7 px-2 flex flex-col justify-start items-center mb-10 min-h-[600px]">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed" color="pink"/> : <></>
      }
      <div className="flex flex-col gap-5 sm:mt-[80px] mt-10">
        <div className="text-white font-bold sm:text-[32px] text-[20px] text-center w-full font-title">
          DUST-20 INSCRIBE
        </div>
        <div className="flex flex-row gap-2 justify-center max-w-[500px] w-full">
          <button className = {`${type == 0 ? 'bg-primary' : 'bg-gray-700'} hover:bg-primary-hover sm:text-[16px] text-[12px] text-white rounded-md px-6 py-2 font-bold`} onClick={() => handleType(0)}>{t('Deploy')}</button>
          <button className = {`${type == 1 ? 'bg-primary' : 'bg-gray-700'} hover:bg-primary-hover sm:text-[16px] text-[12px] text-white rounded-md px-8 py-2 font-bold`} onClick={() => handleType(1)}>{t('Mint')}</button>
          <button className = {`${type == 2 ? 'bg-primary' : 'bg-gray-700'} hover:bg-primary-hover sm:text-[16px] text-[12px] text-white rounded-md px-8 py-2 font-bold`} onClick={() => handleType(2)}>{t('Transfer')}</button>
        </div>
      </div>
      <div className={`flex flex-row bg-gray-900 rounded-md ${type == 2 ? 'w-[700px]' : 'max-w-[500px]'} w-full mt-2 px-5 py-10`}>
      {
        type == 0 ? 
        <div className="flex flex-col gap-6 w-full items-center">
          <div className="max-w-[300px] w-full">
            <Input label={t('Ticker')} type="text" color="white" value={ticker} onChange={(e) => { handleTicker(e.target.value)}}/>
          </div>
          <div className="max-w-[300px] w-full">
            <Input label={t('Supply')} type="number" color="white" value={supply} onChange={(e) => { setSupply(e.target.value)}}/>
          </div>
          <div className="max-w-[300px] w-full">
            <Input label={t('Unit Sats')} type="number" color="white" value={unitSats} onChange={(e) => { setUnitSats(e.target.value)}}/>
          </div>
          <div className="max-w-[300px] w-full">
            <Input label={t('Max Sats')} type="number" color="white" value={maxSats} readOnly/>
          </div>
          <div className="max-w-[300px] w-full">
            <Input label={t('Lim Sats')} type="number" color="white" value={limSats} onChange={(e) => { setLimSats(e.target.value)}}/>
          </div>
          <button className = {`bg-primary hover:bg-primary-hover text-[16px] text-white rounded-md px-8 py-2 font-bold`} onClick={() => handleSubmit(0)}>{t('DEPLOY')}</button>
        </div> 
        :
        <>
        </>
      }
      {
        type == 1 ? 
        <div className="flex flex-col gap-6 w-full items-center">
          <div className="max-w-[300px] w-full relative">
            <Input label={t('Ticker')} type="text" color="white" value={ticker} onChange={(e) => { handleMintTicker(e.target.value)}}/>
            {
              isDeployTickerValid ?
              <div className="text-primary absolute right-5 top-2 font-bold">
                <CheckIcon strokeWidth={2} className="h-5 w-5" /> 
              </div>
              :
              <></>
            }
          </div>
          <div className="max-w-[300px] w-full">
            <Input label={t('Amount')} type="number" color="white" value={amount} onChange={(e) => { setAmount(e.target.value)}}/>
          </div>
          
          <button className = {`bg-primary hover:bg-primary-hover text-[16px] text-white rounded-md px-8 py-2 font-bold`} onClick={() => handleSubmit(1)}>{t('MINT')}</button>
        </div> 
        :
        <></>
      }
      {
        type == 2 ? 
        <div className="flex flex-col gap-6 w-full items-center">
          <div className="max-w-[300px] w-full relative">
            <Input label={t('Ticker')} type="text" color="white" value={ticker} onChange={(e) => { handleMintTicker(e.target.value)}}/>
            {
              isDeployTickerValid ?
              <div className="text-primary absolute right-5 top-2 font-bold">
                <CheckIcon strokeWidth={2} className="h-5 w-5" /> 
              </div>
              :
              <></>
            }
          </div>
          {
            isDeployTickerValid ?
            <div className="flex flex-col gap-2 w-full">
              <div className="flex flex-col w-full gap-1 p-2 border-solid border-[2px] border-gray-800 rounded-md">
                <div className="flex flex-col gap-2 items-end mt-2">
                  <div className="max-w-[250px] w-full">
                    <Input label={t('Search By Amount')} type="number" color="white" value={searchAmount} onChange={(e) => { handleSearchAmount(e.target.value)}}/>
                  </div>
                  <div className="max-w-[250px] w-full">
                    <Input label={t('Search By Output')} type="text" color="white" value={searchOutput} onChange={(e) => { handleSearchOutput(e.target.value)}}/>
                  </div>
                </div>
                <div className="grid md:grid-cols-3 grid-cols-1 gap-3 w-full mt-5">
                {
                  dust20Data.length > 0 ? 
                    dust20Data.map((data) => {
                      return <Dust20TransferCard key={data.output} data = {data}  handle = {handleCheck}/>
                    }) : <></>
                }
                </div>
                <div className="flex flex-col gap-2 w-full mt-5 items-center">
                {
                  checkedData.length > 0 ? 
                    checkedData.map((data) => {
                      return <div className="text-white">{formatInscriptionId(data.output)} &nbsp;,&nbsp; {data.amount}</div>
                    }) : <></>
                }
                </div>
              </div>
              <div className="w-full mt-2">
                <Input label={t('Recipient')} type="text" color="white" value={receiveAddress} onChange={(e) => { handleReceiveAddress(e.target.value)}}/>
              </div>
              <div className="grid grid-cols-3 gap-3 w-full mt-2">
                <FeeRateCard header={feeRateTabs[1]} rate={feeRates[feeRateTabs[1]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[1])}}/>
                <FeeRateCard header={feeRateTabs[2]} rate={feeRates[feeRateTabs[2]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[2])}}/>
                <FeeRateCard header={feeRateTabs[3]} rate={customFee} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[3])}}/>
              </div>
              {
                feeRateMode == "Custom" ? 
                <div className="w-full">
                  <Slider color="blue" value = {sliderValue} onChange = {(e) => setSliderValue(e.target.value)}/>
                </div>
                : 
                <></>
              }
              {
                errorMessage != '' ? 
                <div className="flex flex-row gap-1 items-center">
                  <ExclamationCircleIcon strokeWidth={3} className="h-6 w-6 text-red-700"/>
                  <div className="text-red-700 font-bold">{errorMessage}</div>
                </div>
                : <></>
              }
              <div className="flex flex-row justify-center w-full mt-4">
                <button className = {`bg-primary hover:bg-primary-hover text-[16px] text-white rounded-md px-10 py-2 font-bold`} onClick={() => handleTransfer()}>{t('TRANSFER')}</button>
              </div>
            </div>
            :
            <></>
          }
        </div> 
        :
        <></>
      }
      </div>
      <Dialog
        open={showFeeRateCard}
        className="bg-gray-900 border-gray-600 border-solid border-[1px]"
        size={"xs"}
      >
        <DialogHeader>
          {
            type == 0 ? 
            <div className="text-primary font-bold sm:text-[32px] text-[24px] text-center w-full mt-3">
              Deploy
            </div> : <></>
          }
          {
            type == 1 ? 
            <div className="text-primary font-bold sm:text-[32px] text-[24px] text-center w-full mt-3">
              Mint
            </div> : <></>
          }
        </DialogHeader>
        <DialogBody>
          <div className='flex flex-col gap-3 w-full items-center'>
            <div className="max-w-[360px] w-full">
              <Input label={t('Inscription Receiver Address')} type="text" color="white" value={receiveAddress} onChange={(e) => { handleReceiveAddress(e.target.value)}}/>
            </div>
            <div className="text-left w-full text-gray-600 mt-2 sm:text-[18px] text-[14px]">
              {t('Select Network Fee You Want')}:
            </div>
            <div className="grid grid-cols-3 gap-3 w-full">
              <FeeRateCard header={feeRateTabs[1]} rate={feeRates[feeRateTabs[1]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[1])}}/>
              <FeeRateCard header={feeRateTabs[2]} rate={feeRates[feeRateTabs[2]]} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[2])}}/>
              <FeeRateCard header={feeRateTabs[3]} rate={customFee} active={feeRateMode} onClick={() => {setFeeRateMode(feeRateTabs[3])}}/>
            </div>
            {
              feeRateMode == "Custom" ? 
              <div className="flex flex-row gap-3 items-center">
                <Slider className= "sm:flex hidden" color="blue" value = {sliderValue} onChange = {(e) => setSliderValue(e.target.value)}/>
                <div className="sm:max-w-[200px] w-full">
                  <Input type="text" color="white" label = "Custom Fee" className="sm:max-w-[200px] w-full" value={customFee} onChange = {(e) => {handleCustomFee(e.target.value)}}/>
                </div>
              </div>
              : 
              <></>
            }
            <div className="m-auto md:w-[400px] w-[260px]">
              <div className="flex flex-row justify-between mt-1 sm:text-[20px] text-[14px]">
                <div className="font-bold">{t('Total Cost')}</div>
                <div className="text-right font-bold text-blue-600">{feeValues["totalFee"] / Math.pow(10, 8)} BTC</div>
              </div> 
            </div>
            <div className="flex flex-row w-full justify-center gap-3 ">
              <button className="bg-primary hover:bg-primary-hover rounded-md py-2 sm:min-w-[200px] min-w-[120px] my-3 text-white" onClick={handleMint}>{t('SUBMIT')}</button>
              <button className="bg-gray-600 rounded-md py-2 sm:min-w-[200px] min-w-[120px] my-3 text-white" onClick={() => setShowFeeRateCard(false)}>{t('CLOSE')}</button>
            </div>
          </div>
        </DialogBody>
      </Dialog>
      <Dialog
        open={show}
        size={"sm"}
      >
        <DialogHeader>
          {
            inscriptionStatus ? <>
                {
                  type == 0 ? 
                  <div className="flex flex-row w-full justify-center items-center gap-3 mt-6 text-[32px] font-bold text-primary">
                    <CheckCircleIcon strokeWidth={2} className="h-16 w-16" /> 
                    <span className="text-primary sm:text-[32px] text-[20px]">
                      {t('Deployment Successful')}.</span>
                  </div>
                  :
                  <></>
                }
                {
                  type == 1 ? 
                  <div className="flex flex-row w-full justify-center items-center gap-3 mt-6 text-[32px] font-bold text-primary">
                    <CheckCircleIcon strokeWidth={2} className="h-16 w-16" /> 
                    <span className="text-primary sm:text-[32px] text-[20px]">
                      {t('Mint successful')}.</span>
                  </div>
                  :<></>
                }
              </>
              :
              <div className="flex flex-row w-full justify-center mt-6 sm:text-[32px] text-[20px] font-bold text-primary">
                {t('Inscribing Now')}
              </div>
          }
        </DialogHeader>
        <DialogBody>
          <div className={`flex flex-col gap-3 w-full ${inscriptionStatus ? 'min-h-[100px]' : 'min-h-[160px]'}`}>
            {
              inscriptionStatus ? 
              <div className="flex flex-col items-center gap-4">
                <div className="w-[180px] mt-5">
                  <Button
                    onClick={() => {
                      setShow(false);
                      setInscriptionStatus(false);
                    }}
                    fullWidth
                  >{t('Close')}</Button>
                </div>
              </div>
              :
              <div className="flex flex-col items-center gap-5">
                <div className="flex flex-row justify-center w-full font-semibold text-[#616161] sm:text-[20px] text-[14px] px-6 text-center">
                  {t('Do Not Close Window Info Message')}
                </div>
                <Spinner className="h-12 w-12" />
              </div>
            }
          </div>
        </DialogBody>
      </Dialog>
    </div>
  )
}
